import React from "react";

export default function ProgressBar({ value, max, testId }) {
  const pct = Math.min(100, Math.round(((value || 0) / Math.max(1, max || 1)) * 100));
  return (
    <div className="lp-progress-track" data-testid={testId || "progress-bar"}>
      <div className="lp-progress-fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
